import { render } from "./Shutdown.vue?vue&type=template&id=50c20a13"
import script from "./Shutdown.vue?vue&type=script&lang=js"
export * from "./Shutdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-Hub\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__